import { useAuth } from "@/lib/auth/AuthContext";

/** Must match `Features::ALL` on the server. */
export const FEATURE_DECISION_LAB = "decision_lab";

/**
 * Whether a flagged section exists for whoever is holding this device.
 *
 * Hiding a nav item is a courtesy to the reader, never the control: every gated
 * resolver checks the same flag again server-side, so a typed URL gets nothing.
 */
export function useFeature(key: string): boolean {
  const { features } = useAuth();
  return features.includes(key);
}
